import React, { ReactNode } from 'react'
import Image from 'next/image'

interface ModalProps {
  className?: any
  showModal: boolean
  setShowModal: (value: boolean) => void
  children: ReactNode
}

const ModalVideo: React.FC<ModalProps> = ({
  children,
  showModal,
  setShowModal
}) => {
  return (
    showModal && (
      <>
        <div
          className="justify-center items-center flex overflow-x-hidden
            overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
          onClick={() => setShowModal(false)}
        >
          <div className="relative w-full my-6 mx-auto max-w-3xl px-6">
            <div className="rounded-md shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
              <div className="absolute -top-3 -right-3 p-1 shadow-md bg-orange rounded-full w-7 h-7">
                <button
                  className="text-black font-bold"
                  type="button"
                  onClick={() => setShowModal(false)}
                >
                  <Image
                    src="/assets/close.svg"
                    height={24}
                    width={24}
                    alt=""
                    loading="lazy"
                  />
                </button>
              </div>
              <div className="relative p-4 flex-auto">{children}</div>
            </div>
          </div>
        </div>
        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
      </>
    )
  )
}

export default ModalVideo
